import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

/**
 * jyyb8AfJ PR 2 — admin deactivate-user confirm modal.
 *
 * Co-located in components/ui/ rather than under a page folder because
 * both workers-list and worker-detail consume it. Mirrors the shared
 * placement used for NoteDeleteConfirmModal (NSherjFh PR 11).
 *
 * Destructive treatment (AlertTriangle + bg-destructive callout) because
 * the action immediately revokes the target's access. Records owned by
 * the user stay attributed by FK join — the umbrella's denormalized-name
 * concern doesn't apply here.
 */
const DeactivateUserConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  isDeactivating = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-5 w-full max-w-md">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="flex items-center justify-center w-12 h-12 bg-destructive/10 rounded-full flex-shrink-0">
              <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-foreground mb-2">
                Deactivate {userName || 'this user'}?
              </h2>
              <p className="text-sm text-muted-foreground">
                They will lose access to SiteProof immediately. All their existing records (notes, completions, assignments, sign-offs) stay in the system with their name still attached.
              </p>
            </div>
          </div>

          <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 mb-2">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Reversible</p>
                <p className="text-sm text-muted-foreground">
                  You can reactivate them later from this page or by re-inviting them — their role and history are preserved.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-4 border-t border-border bg-muted/30">
          <Button variant="outline" onClick={onClose} disabled={isDeactivating}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeactivating}
            iconName={isDeactivating ? 'Loader2' : 'UserX'}
            iconPosition="left"
          >
            {isDeactivating ? 'Deactivating…' : 'Deactivate'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateUserConfirmModal;
